import { render, staticRenderFns } from "./SimilarOptions.vue?vue&type=template&id=33298727&scoped=true&"
import script from "./SimilarOptions.vue?vue&type=script&lang=js&"
export * from "./SimilarOptions.vue?vue&type=script&lang=js&"
import style0 from "./SimilarOptions.vue?vue&type=style&index=0&id=33298727&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33298727",
  null
  
)

export default component.exports